import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgBitcoin = function SvgBitcoin(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#F7931A",
        d: "M118.205 74.514c-8.013 32.143-40.57 51.705-72.716 43.69C13.355 110.19-6.206 77.632 1.81 45.492 9.82 13.345 42.376-6.218 74.513 1.795c32.145 8.014 51.706 40.575 43.691 72.72z"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M86.464 51.451c1.194-7.984-4.885-12.276-13.197-15.14l2.696-10.815-6.584-1.641-2.625 10.531c-1.73-.432-3.508-.838-5.275-1.242l2.644-10.6-6.58-1.64-2.698 10.811c-1.432-.326-2.839-.648-4.204-.988l.008-.034-9.08-2.267-1.751 7.032s4.885 1.12 4.782 1.189c2.666.665 3.148 2.43 3.068 3.83l-3.072 12.321c.184.047.422.114.685.22l-.191-.048q-.245-.061-.505-.124l-4.306 17.26c-.326.81-1.153 2.027-3.017 1.565.066.096-4.785-1.194-4.785-1.194l-3.269 7.536 8.568 2.136q1.407.356 2.783.716h.002q.96.253 1.91.495L39.745 92.3l6.576 1.641 2.698-10.824c1.797.488 3.54.938 5.247 1.362l-2.689 10.773 6.584 1.64 2.725-10.92c11.227 2.126 19.669 1.269 23.222-8.886 2.863-8.176-.142-12.892-6.05-15.967 4.303-.992 7.543-3.822 8.407-9.667zM71.421 72.546c-1.867 7.5-13.608 4.4-18.98 2.98-.483-.127-.915-.241-1.283-.332L54.773 60.7c.449.112.997.235 1.619.374 5.557 1.248 16.942 3.802 15.03 11.472M57.507 54.348c4.478 1.195 14.249 3.803 15.95-3.015 1.738-6.973-7.757-9.075-12.394-10.102a57 57 0 0 1-1.358-.31l-3.278 13.144c.31.077.673.174 1.08.283",
        clipRule: "evenodd"
    })));
};

export { SvgBitcoin as ReactComponent };
//# sourceMappingURL=Bitcoin.svg.es.js.map
